import Utilities from '@/Utility/Utilities';
import { NodeData } from '#/DefaultViewExtensionInterfaces';

export default class TreeUtilities {

    public static getAllChildren<T>(collection: Array<T>, childrenAttribute: string): Array<T> {
        if (_.isEmpty(collection)) {
            return [];
        }

        return _.flatten([]
            .concat(collection)
            .concat(collection.map(node => {

                let children = node[childrenAttribute];
                if (ko.isObservable(children)) {
                    return TreeUtilities.getAllChildren(children(), childrenAttribute);
                }

                return TreeUtilities.getAllChildren(children, childrenAttribute);
            }))
        );
    }

    public static getAllChildrenDepthFirst<T>(collection: Array<T>, childrenAttribute: string): Array<T> {
        if (_.isEmpty(collection)) {
            return [];
        }

        return _.flatten([]
            .concat(collection.map(node => {
                let children = node[childrenAttribute];

                if (ko.isObservable(children)) {
                    return [node].concat(TreeUtilities.getAllChildrenDepthFirst(children(), childrenAttribute));
                }

                return [node].concat(TreeUtilities.getAllChildrenDepthFirst(children, childrenAttribute));
            }))
        );
    }


    public static getParentByKey(collection: Array<NodeData>, key: string, parent?: NodeData): NodeData {
        if (Utilities.findFirst(collection, anyNode => anyNode.key == key) != null) {
            return parent || null;
        }
        else {
            for (let node of collection) {
                parent = TreeUtilities.getParentByKey(node.children || [], key, node);
                if (parent != null) {
                    return parent;
                }
            }
        }

        return null;
    }

    public static getNodeByPredicate<T extends NodeData>(collection: Array<T>, predicate: Predicate, childrenAttributeKey?: string): T {
        let match = Utilities.findFirst(collection, anyNode => predicate(anyNode));
        if (match != null) {
            return match;
        }

        for (let node of collection) {
            if (match == null) {
                match = TreeUtilities.getNodeByPredicate(node[childrenAttributeKey || "children"] || [], predicate);
            }
            else {
                return match;
            }
        }

        return match;
    }

    public static getNodeByKey(collection: Array<NodeData>, key: string): NodeData {
        if (Utilities.isNullOrUndefined(key)) {
            return null;
        }

        return TreeUtilities.getNodeByPredicate(collection, anyNode => anyNode.key == key, "children");
    }

    public static removeNode(collection: Array<NodeData>, node: NodeData): NodeData {
        return TreeUtilities.removeNodeByKey(collection, node.key);
    }

    public static removeNodeByKey(collection: Array<NodeData>, key: string): NodeData {
        let index = _.findIndex(collection, anyNode => anyNode.key == key);
        let match = null;
        if (index !== -1) {
            match = collection[index];
            collection.splice(index, 1);

            return match;
        }
        
        for (let node of collection) {
            match = TreeUtilities.removeNodeByKey(node.children || [], key);

            if (match != null) {
                return match;
            }
        }

        return match;
    }

    public static insertNode(rootNodes: Array<NodeData>, node: NodeData, parent?: NodeData): void {
        if (Utilities.isNullOrUndefined(parent)) {
            rootNodes.push(node);
        }
        else {
            parent.children = parent.children || [];
            parent.children.push(node);
        }
    }
}

interface Predicate {
    (...args: any[]): boolean;
}